import React from "react";

const Data = () => {
    return (
        <div className="about__data">
            <h1 className="about__title"> Wanjia Fu
            </h1>
            <h3 className="about__subtitle"> wanjia.fu [at] engineering.upenn.edu</h3>
            <p className="about__description">
                I am a first-year Ph.D. student in CIS and GRASP Lab at the <a href="https://www.cis.upenn.edu/" target="_blank" rel="noreferrer" className="is__link">
                University of Pennsylvania
                    </a>, advised by Prof. <a href="https://jiayuanm.com/" target="_blank" rel="noreferrer" className="is__link">
                Jiayuan Mao
                    </a> and Prof. <a href="https://www.engineering.upenn.edu/~rhollada/" target="_blank" rel="noreferrer" className="is__link">
                Rachel Holladay
                    </a>. I previously earned my honors in Sc.B in Computer Science and A.B in Applied Maths from <a href="https://cs.brown.edu/" target="_blank" rel="noreferrer" className="is__link">
                    Brown University
                    </a> with magna cum laude, where I worked in the Interactive 3D Vision & Learning Lab with Prof. <a href="https://cs.brown.edu/people/ssrinath/" target="_blank" rel="noreferrer" className="is__link">
                Srinath Sridhar
                    </a> and Intelligent Robotics Lab with Prof. <a href="https://cs.brown.edu/people/gdk/" target="_blank" rel="noreferrer" className="is__link">
                George Konidaris
                    </a> and Prof. <a href="https://cs.brown.edu/people/stellex/" target="_blank" rel="noreferrer" className="is__link">
                Stefanie Tellex
                    </a>.
            </p>
            <p className="about__description">
            My research focuses on embodied AI and tactile sensing. Specifically, my goal is to incorporate the modality of touch into contact-rich dexterous manipulation, world modeling, and robot learning.
            </p>
        </div>
    )
}

export default Data;